import React from 'react';

export const MapDistanceInfo = ({ distance, routeDistance, routeDuration }) => {
  // The live map routing can differ from the saved kilometres used by the list,
  // PDF and settlement, so it is shown separately and never replaces them.
  const savedDistance = Number(distance) || 0;
  const hasMapDistance = routeDistance > 0;
  const avgSpeed = hasMapDistance && routeDuration > 0
    ? Math.round((routeDistance / (routeDuration / 3600)) * 10) / 10
    : null;

  return (
    <div className="map-info-box map-info-box--compact">
      <div className="map-info-box__metric">
        <span className="map-info-box__label">{__('routes.distance_sum')}</span>
        <span className="map-info-box__value">{savedDistance} km</span>
      </div>
      {hasMapDistance && (
        <div className="map-info-box__metric">
          <span className="map-info-box__label">{__('routes.map_distance')}</span>
          <span className="map-info-box__value">{routeDistance} km</span>
        </div>
      )}
      {avgSpeed !== null && (
        <div className="map-info-box__metric">
          <span className="map-info-box__label">{__('routes.map_avg_speed')}</span>
          <span className="map-info-box__value">{avgSpeed} km/h</span>
        </div>
      )}
    </div>
  );
};
